import { render, staticRenderFns } from "./sowhatbuy-features-slider.vue?vue&type=template&id=a49d5fd8&"
import script from "./sowhatbuy-features-slider.vue?vue&type=script&lang=js&"
export * from "./sowhatbuy-features-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports